<template>
  <div></div>
</template>

<script type="text/babel">
import activityItem from "../../../../mixins/activity-item";

export default {
  mixins: [activityItem],

  props: ["activity"],
};
</script>
